<form [formGroup]="passwordForm" id="changepasswordform" (ngSubmit)="onSubmit($event)">
  <fieldset>
    <div>
      <label for="oldPassword">{{ "Template.PasswordChangeComponent.label_oldPassword" | translate }}*</label>
      <input type="password" class="form-control" name="oldPassword" id="oldPassword" formControlName="oldPassword" maxlength="20" autocomplete="off" data-lpignore="true" />
      @if (passwordForm.get('oldPassword')?.errors?.['oldPasswordInvalid']) {
        <small class="text-danger">{{ "Template.PasswordChangeComponent.msg_oldPasswordInvalid" | translate }}</small>
      }
    </div>
    <div class="mt-4">
      <label for="newPassword">{{ "Template.PasswordChangeComponent.label_newPassword" | translate }}* </label>
      <input type="password" class="form-control" name="newPassword" id="newPassword" formControlName="newPassword" maxlength="20" autocomplete="off" data-lpignore="true" ngbTooltip="{{ 'Template.PasswordChangeComponent.tooltip_newPassword' | translate }}" (input)="onNewPasswordInput()" />
      <app-password-strength [passwordToCheck]="newPassword"></app-password-strength>
      @if (passwordForm && passwordForm.get('newPassword') && passwordForm.get('newPassword')?.errors && passwordForm.get('newPassword')?.hasError('pattern')) {
        <small class="text-danger">
          {{ "Template.PasswordChangeComponent.msg_errorNoCriteriaMatch" | translate }}
        </small>
      }
    </div>
    <div class="mt-4">
      <label for="newPasswordVerify">{{ "Template.PasswordChangeComponent.label_newPasswordVerify" | translate }}* </label>
      <input type="password" class="form-control" name="newPasswordVerify" id="newPasswordVerify" formControlName="newPasswordVerify" maxlength="20" autocomplete="off" data-lpignore="true" />
    </div>
  </fieldset>

  <div class="mt-2">
    <label>
      <small>{{ "Template.PasswordChangeComponent.label_commonFieldsMarkedAreRequired" | translate }}</small>
    </label>
  </div>

  <div class="mt-2">
    <button type="submit" class="btn btn-success d-block w-100" [disabled]="!passwordForm.valid">
      {{ "Template.PasswordChangeComponent.btn_save" | translate }}
      @if (!loadingSave) {
        <fa-icon icon="chevron-right"></fa-icon>
      }
      @if (loadingSave) {
        <fa-icon icon="spinner" animation="spin"></fa-icon>
      }
    </button>
  </div>
</form>
